import styled from '@emotion/styled/macro';

export const NoteContainer = styled.div`
  > div {
    color: #5c5c5c;
    font-size: 0.95rem;
    font-weight: 300;
  }
`;
